<template>
  <div class="home-wrapper">
    <stack :column-min-width="220" :gutter-height="10" monitor-images-loaded>
      <stack-item
        v-for="(image, i) in images"
        :key="i"
        style="transition: transform 300ms"
      >
        <img
          class="image-wrapper"
          :src="image.urls.thumb"
          :alt="image.alt_description"
          @click="handlePhotoPage(image.id)"
        />
      </stack-item>
    </stack>
    <div class="intersect">
      <intersect @enter="scroll()">
        <div class="loading"><h1>Loading</h1></div>
      </intersect>
    </div>
  </div>
</template>

<script>
  import Intersect from "vue-intersect";
  import { Stack, StackItem } from "vue-stack-grid";

  export default {
    name: "Home",
    components: {
      Stack,
      StackItem,
      Intersect,
    },
    data: () => ({
      images: [],
      page: 1,
    }),
    methods: {
      scroll() {
        this.page = this.page + 1;
        console.log("leave");
      },
      handlePhotoPage(id) {
        this.$router.push(`/photo/${id}`);
      },
      getRandomImages() {
        this.$http.get(`/photos?per_page=30&page=${this.page}`).then((res) => {
          //this.images = res.data;
          this.images.push(...res.data);
          console.log(res);
        });
      },
    },
    watch: {
      page() {
        this.getRandomImages();
      },
    },
    created() {
      this.getRandomImages();
    },
  };
</script>

<style lang="scss" scoped>
  .home-wrapper {
    width: 95%;
    display: flex;
    min-height: 95vh;
    margin-top: 3rem;
    flex-direction: column;
    .pagination {
      position: absolute;
      bottom: -25rem;
      left: 0;
    }

    .image-wrapper {
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
        0 4px 6px -2px rgba(0, 0, 0, 0.05);
      cursor: pointer;
      transition: all 0.2s linear;

      &:hover {
        transform: scale(1.1);
        z-index: 10;
        filter: brightness(0.7);
      }
    }
    .intersect {
      opacity: 0;
    }
  }
  .vsg-container {
    // height: 0 !important;
    //min-height: 100% !important;
  }
  .stack {
    width: 100%;
    min-height: 100vh;
  }
</style>
